import { render, staticRenderFns } from "./table.vue?vue&type=template&id=bb258e28&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb258e28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb258e28')) {
      api.createRecord('bb258e28', component.options)
    } else {
      api.reload('bb258e28', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=bb258e28&scoped=true", function () {
      api.rerender('bb258e28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/upgradePopupManage/components/table.vue"
export default component.exports